module.exports = __webpack_public_path__ + "static/media/veneto-village-24.81395c95.jpg";